import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { FileUpload } from "primereact/fileupload";
import React from "react";

import Spinner from "presentation/components/Shared/Spinner";

interface EquipmentDocumentsTabProps {
  equipmentId?: string;
  loadingDocs: boolean;
  documents: any[];
  userEmail?: string;
  isAdminOrPatrimonio: boolean;
  tabContentStyle: React.CSSProperties;
  fileUploadRef: React.RefObject<FileUpload | null>;
  onUploadDoc: (event: any) => void;
  onViewDoc: (fileKey: string, title: string) => void;
  onDeleteDoc: (docId: string) => void;
}

const EquipmentDocumentsTab: React.FC<EquipmentDocumentsTabProps> = ({
  equipmentId,
  loadingDocs,
  documents,
  userEmail,
  isAdminOrPatrimonio,
  tabContentStyle,
  fileUploadRef,
  onUploadDoc,
  onViewDoc,
  onDeleteDoc,
}) => {
  return (
    <div style={tabContentStyle}>
      <div className="mb-3">
        <div className="flex justify-content-between align-items-center mb-2">
          <h3 className="m-0">Anexos e Documentos</h3>

          <FileUpload
            ref={fileUploadRef}
            mode="basic"
            name="file"
            accept=".pdf,.jpg,.png"
            maxFileSize={10000000}
            customUpload
            auto
            uploadHandler={onUploadDoc}
            chooseLabel="Novo Ficheiro"
            className="w-auto p-button-sm"
            disabled={!equipmentId}
          />
        </div>
      </div>

      {!equipmentId && (
        <div className="text-center text-gray-500 py-4">
          Os documentos ficam disponíveis depois de guardar o equipamento pela
          primeira vez.
        </div>
      )}

      {equipmentId &&
        (loadingDocs ? (
          <Spinner />
        ) : (
          <DataTable
            value={documents}
            paginator
            rows={5}
            className="mt-2 text-sm"
          >
            <Column field="name" header="Nome do Ficheiro" />
            <Column
              field="uploadedAt"
              header="Carregado Em"
              body={(row) =>
                new Date(row.uploadedAt).toLocaleDateString("pt-PT")
              }
            />
            <Column
              field="uploadedByName"
              header="Carregado Por"
              body={(row) => row.uploadedByName || row.uploadedBy?.name || "-"}
            />
            <Column
              header="Ações"
              body={(row) => {
                const isMyDoc = row.uploadedBy === userEmail;
                const isToday =
                  new Date(row.uploadedAt).toDateString() ===
                  new Date().toDateString();
                const canDelete = isAdminOrPatrimonio || (isMyDoc && isToday);

                return (
                  <div className="flex gap-2">
                    <Button
                      icon="pi pi-eye" severity="secondary"
                      className="p-button-rounded p-button-text p-button-sm"
                      onClick={() => onViewDoc(row.fileKey, row.name)}
                      tooltip="Visualizar"
                    />
                    {canDelete && (
                      <Button
                        icon="pi pi-trash" severity="secondary"
                        className="p-button-rounded p-button-text p-button-sm"
                        onClick={() => onDeleteDoc(row.id)}
                        tooltip="Eliminar"
                      />
                    )}
                  </div>
                );
              }}
            />
          </DataTable>
        ))}
    </div>
  );
};

export default EquipmentDocumentsTab;
